import { useState } from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";
import { RARITY_STYLES, colorHex } from "@/lib/constants";
import { ImageOff, X } from "lucide-react";
import { ZoomImage } from "@/components/ZoomImage";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export function InsulatorCard({ ins }) {
  const swatch = colorHex(ins.color);
  const [imgErr, setImgErr] = useState(false);
  const [lightbox, setLightbox] = useState(false);
  const showImg = ins.image_url && !imgErr;
  return (
    <Link
      to={`/catalog/${ins.id}`}
      data-testid={`insulator-card-${ins.id}`}
      className="group surface border rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl block"
      style={{ boxShadow: "0 4px 20px -8px rgba(217,119,6,0.15)" }}
    >
      <div className="relative aspect-square overflow-hidden glass-glow" style={{ background: `radial-gradient(circle at 50% 40%, ${swatch}22, transparent 70%)` }}>
        {showImg ? (
          <div className="w-full h-full p-4">
            <ZoomImage
              src={ins.image_url}
              alt={ins.name}
              enlargeOnImageClick={false}
              onEnlarge={() => setLightbox(true)}
              lensSize={150}
            />
          </div>
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center gap-2 text-muted-page" data-testid="insulator-no-image">
            <ImageOff className="w-8 h-8 opacity-40" />
            <span className="font-tech text-xs">No photo yet</span>
          </div>
        )}
        <span className={`absolute top-3 left-3 text-[10px] font-tech uppercase tracking-wider px-2 py-1 rounded-full border z-10 ${RARITY_STYLES[ins.rarity] || RARITY_STYLES.Common}`}>
          {ins.rarity}
        </span>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-1">
          {ins.cd_number && <span className="font-tech text-xs px-2 py-0.5 rounded" style={{ background: "var(--honey-100)", color: "var(--honey-900)" }}>{ins.cd_number}</span>}
          <span className="w-3 h-3 rounded-full border border-black/10" style={{ background: swatch }} title={ins.color} />
        </div>
        <h3 className="font-display text-xl font-bold leading-tight group-hover:brand-text transition-colors">{ins.name}</h3>
        <p className="text-sm text-muted-page">{[ins.maker, ins.color].filter(Boolean).join(" · ")}</p>
        <p className="mt-2 font-tech text-sm brand-text">{ins.est_value_low || ins.est_value_high ? `$${ins.est_value_low} – $${ins.est_value_high}` : <span className="text-muted-page">Value —</span>}</p>
      </div>

      {showImg && (
        <Dialog open={lightbox} onOpenChange={setLightbox}>
          <DialogContent className="surface max-w-5xl w-[95vw] p-0 overflow-hidden" data-testid={`card-lightbox-${ins.id}`} onClick={(e) => e.preventDefault()}>
            <DialogTitle className="sr-only">{ins.name} image viewer</DialogTitle>
            <div className="relative bg-black/90 flex items-center justify-center" style={{ minHeight: "60vh", maxHeight: "82vh" }}>
              <img src={mediaUrl(ins.image_url)} alt={ins.name} className="max-w-full max-h-[82vh] object-contain" />
              <button
                type="button"
                data-testid={`card-lightbox-close-${ins.id}`}
                onClick={(e) => { e.preventDefault(); setLightbox(false); }}
                className="absolute top-3 right-3 w-10 h-10 rounded-full bg-white/90 grid place-items-center hover:bg-white"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </Link>
  );
}
